import { Region } from '@leid/api-locations'
import { Location } from '@leid/api-locations'
import { ProductAvailabilityInfo } from '@leid/api-orders'

import { AvailabilityInfo } from '../availabilityInfo'

export const getAvailableLocations = (
  selectedRegionId: number | undefined,
  availabilityInfo: AvailabilityInfo[],
  originalRegions: Region[],
): Location[] => {
  let regionIdsChain: number[] | undefined
  if (selectedRegionId) {
    regionIdsChain = getChainBelowRegionIds(selectedRegionId, originalRegions)
  }

  return availabilityInfo
    .filter(
      (s) => s.correct && !s.isRerent && (!regionIdsChain || regionIdsChain.some((x) => x === s.location.regionId)),
    )
    .map((s) => s.location)
}

export const getUnavailableLocations = (
  selectedRegionId: number | undefined,
  availabilityInfo: AvailabilityInfo[],
  originalRegions: Region[],
): Location[] => {
  let regionIdsChain: number[] | undefined
  if (selectedRegionId) {
    regionIdsChain = getChainBelowRegionIds(selectedRegionId, originalRegions)
  }

  return availabilityInfo
    .filter(
      (s) => (!s.correct || s.isRerent) && (!regionIdsChain || regionIdsChain.some((x) => x === s.location.regionId)),
    )
    .map((s) => s.location)
}

export const findSelectedLocation = (
  locationId: number,
  selectedRegionId: number | undefined,
  availabilityInfo: AvailabilityInfo[],
  originalRegions: Region[],
): AvailabilityInfo | undefined => {
  let regionIdsChain: number[] | undefined
  if (selectedRegionId) {
    regionIdsChain = getChainBelowRegionIds(selectedRegionId, originalRegions)
  }

  const selectedLocation = availabilityInfo.find(
    (s) => s.location.id === locationId && (!regionIdsChain || regionIdsChain.some((x) => x === s.location.regionId)),
  )

  return selectedLocation
}

export const hasRealAssets = (locationId: number, productCalendarList: ProductAvailabilityInfo): boolean => {
  const availabilityInfo = productCalendarList.locations.find((s) => s.locationId === locationId)
  if (!availabilityInfo) {
    return false
  }

  return availabilityInfo.hasRealAssets
}

export const hasAnyAvailableItems = (locationId: number, productCalendarList: ProductAvailabilityInfo): boolean => {
  const availabilityInfo = productCalendarList.locations.find((s) => s.locationId === locationId)
  if (!availabilityInfo) {
    return false
  }

  return availabilityInfo.availabilityInfo.some((s) => s.amount !== 0)
}

export const getChainBelowRegionIds = (regionId: number, originalRegions: Region[]): number[] => {
  const result = [regionId]

  const region = originalRegions.find((s) => s.id === regionId)
  if (!region) {
    return result
  }

  for (const childRegionId of region.childRegions ?? []) {
    const childRegionIds = getChainBelowRegionIds(childRegionId, originalRegions)
    result.push(...childRegionIds)
  }

  return result
}

export const getChainAboveRegionIds = (regionId: number, originalRegions: Region[]): number[] => {
  const result = [regionId]

  console.log(originalRegions, regionId)

  const region = originalRegions.find((s) => s.id === regionId)
  if (!region) {
    return result
  }

  const parentRegions = originalRegions.filter(
    (s) => s.id !== region.id && s.childRegions && s.childRegions.some((x) => x === region.id),
  )
  for (const parentRegion of parentRegions) {
    const parentRegionIds = getChainAboveRegionIds(parentRegion.id, originalRegions)
    result.push(...parentRegionIds)
  }

  return result
}

export const getOriginalAvailableLocations = (
  productLocations: Location[],
  productCalendarList: ProductAvailabilityInfo,
): Location[] => {
  const locationsWithRealAssets =
    productLocations.filter(
      (s) => hasRealAssets(s.id, productCalendarList) && hasAnyAvailableItems(s.id, productCalendarList),
    ) ?? []
  return locationsWithRealAssets
}
